/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Currency unit for cost amounts. Use `CREDITS` for Eon credits and `USD` for U.S. dollars. `UNSPECIFIED` is supported only in responses. 
*/
export enum CostUnit {
  COST_UNIT_CREDITS = 'CREDITS',
  COST_UNIT_USD = 'USD',
  COST_UNIT_UNSPECIFIED = 'UNSPECIFIED'
}
